import { createAction, props } from '@ngrx/store';
import { DashboardItem, MenuItem, Toast, UserProfile } from '../../models';
import { AppConfig } from 'src/app/models/app-config.model';

export const loadUserProfile = createAction('[UserProfile] Load UserProfile');
export const loadUserProfileSuccess = createAction('[UserProfile] Load UserProfile Success', props<{ profile: UserProfile }>());
export const loadUserProfileFailure = createAction('[UserProfile] Load UserProfile Failure', props<{ error: any }>());

export const loadMenuSuccess = createAction('[UserProfile] Load Menu Success', props<{ menuItems: MenuItem[] }>());
export const loadMenuFailure = createAction('[UserProfile] Load Menu Fail', props<{ error: any }>());

export const loadDashboardSuccess = createAction('[UserProfile] Load Dashboard Success', props<{ dashboardItems: DashboardItem[] }>());
export const loadDashboardFailure = createAction('[UserProfile] Load Dashboard Fail', props<{ error: any }>());

export const logout = createAction('[UserProfile] Logout');
export const logoutSuccess = createAction('[UserProfile] Logout Success');
export const logoutFail = createAction('[UserProfile] Logout Fail', props<{ error: any }>());

export const loadAppConfig = createAction('[UserProfile] load app config');
export const loadAppConfigSuccess = createAction('[UserProfile] load app config success', props<{ config: AppConfig[] }>());
export const loadAppConfigFail = createAction('[UserProfile] load app config fail', props<{ error: any }>());
